<script setup lang="ts">
import { parseISO } from "date-fns"
import TooltipContent from "~ui/components/TooltipContent.vue"

const { simulationKickoffDate, trainingKickoffDate } = defineProps<{
  simulationKickoffDate: string
  trainingKickoffDate: string
}>()

const { getDateWithOptions } = useLocalisedDate()

function formatKickoffDate(date: string) {
  return getDateWithOptions(parseISO(date), { dateStyle: "medium" })
}
</script>

<template>
  <TooltipContent
    side="right"
    :side-offset="10"
    class="w-64 max-w-none rounded-xl border border-zinc-200 bg-white p-0 text-zinc-900 shadow-lg select-text"
  >
    <div class="flex items-center gap-2.5 p-3">
      <div
        class="flex size-7 shrink-0 items-center justify-center rounded-full bg-radial-[at_25%_25%] from-violet-200 to-fuchsia-50 to-75% text-violet-500"
      >
        <SvgoPikaRocketShip class="size-4" aria-hidden="true" />
      </div>
      <TypographyText class="text-zinc-900">
        <TypographyStrong>
          {{ $t("workspace_onboarding.progress_badge.kick_off_planned") }}
        </TypographyStrong>
      </TypographyText>
    </div>

    <dl class="space-y-2 border-t border-zinc-100 p-3 pt-3 text-xs">
      <div class="flex items-center justify-between gap-4">
        <dt class="text-zinc-500">
          {{ $t("workspace_onboarding.progress_badge.training_start") }}:
        </dt>
        <dd class="font-medium text-zinc-900">
          {{ formatKickoffDate(trainingKickoffDate) }}
        </dd>
      </div>
      <div class="flex items-center justify-between gap-4">
        <dt class="text-zinc-500">
          {{ $t("workspace_onboarding.progress_badge.simulation_date") }}:
        </dt>
        <dd class="font-medium text-zinc-900">
          {{ formatKickoffDate(simulationKickoffDate) }}
        </dd>
      </div>
    </dl>
  </TooltipContent>
</template>
